module.exports = __webpack_public_path__ + "static/media/bg-image-3.265ef687.jpg";